import globals = require("globals");
var index = 1;
var cb = "_asyncApiLoaderCallback";
var cache = [];

let g = window["globals"] = (window["globals"] || globals);

class Async {
    
    static about = `Plugin to load data as modules`;

    static load(param, req, loadCallback) {
        if (0 <= cache.indexOf(req))
            return;
        cache.push(req);
        var cbName = cb + index++;
        g[cbName] = function () {
            delete g[cbName];
            loadCallback();
        };
        requirejs([param + "&callback=globals." + cbName]);
    }
}

export = Async;